import { render, staticRenderFns } from "./BatchDetailsPage.vue?vue&type=template&id=3c35bd1c&"
import script from "./BatchDetailsPage.vue?vue&type=script&lang=js&"
export * from "./BatchDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./BatchDetailsPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports